import styled, { css } from 'styled-components'

export const TabsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;

  @media (max-width: 767px) {
    overflow-x: auto;
    flex-wrap: nowrap;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const Tab = styled.div<{ $isActive?: boolean }>`
  display: flex;
  padding: 1rem 1.5rem;
  align-items: center;
  border-radius: 10rem;
  background: ${({ $isActive }) => ($isActive ? '#3A64F8' : '#525c7a')};
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;

  color: white;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;

  &:active {
    background-color: #3a64f8;
  }

  &:hover {
    background-color: #667399;
    transition: background-color 0.1s ease;
  }
`

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  align-items: center;
`

export const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;

  @media (max-width: 767px) {
    width: 100%;
  }
`

const cardBase = css`
  display: flex;
  border-radius: 2rem;
  border: 1px solid #47506b;
  background-color: #333a4d;
  backdrop-filter: blur(5.5px);
  padding: 1rem;
  height: 27rem;

  @media (max-width: 767px) {
    flex-direction: column;
    height: 100%;
    padding: 1.5rem;
    gap: 1.5rem;
  }
`

export const CardBig = styled.div`
  ${cardBase}
  width: 76.7rem;

  @media (max-width: 1279px) {
    width: 100%;
  }
`

export const CardSmall = styled.div`
  ${cardBase}
  width: 37.3rem;

  @media (max-width: 1279px) {
    width: calc(50% - 1rem);
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`

export const CardContentLeft = styled.div<{ $isBig?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 25rem;
  border-radius: 1rem;
  background: linear-gradient(180deg, rgba(69, 78, 104, 0) 0%, #454e68 100%);

  ${({ $isBig }) =>
    $isBig
      ? css`
          width: 25rem;
          padding: 4rem 7.5rem 1.4rem 7.5rem;
        `
      : css`
          width: 12rem;
          padding: 4rem 1.4rem 1.4rem 1.4rem;
        `}

  @media (max-width: 767px) {
    display: none;
  }
`

export const CardLogoWrapper = styled.div<{ $isBig?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2rem;
  background: white;
  box-shadow: 0 6.667px 50px 0 #7984a5;

  ${({ $isBig }) =>
    $isBig
      ? css`
          padding: 2rem;
          width: 10rem;
          height: 10rem;
        `
      : css`
          padding: 1.6rem;
          width: 8rem;
          height: 8rem;
        `}
`

export const CardContentLogo = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.8rem;
    background: white;
    box-shadow: 0 6.667px 50px 0 #7984a5;
    width: 4rem;
    height: 4rem;
    margin-right: 1.2rem;
  }
`

export const CardLogoImage = styled.img<{ $isBig?: boolean }>`
  width: ${({ $isBig }) => ($isBig ? '10.2rem' : '8.2rem')};
  height: ${({ $isBig }) => ($isBig ? '10.2rem' : '8.2rem')};
  object-fit: contain;
  border-radius: 1.6rem;
`

export const CardContentLogoImage = styled.img`
  width: 4.2rem;
  height: 4.2rem;
  object-fit: contain;
  border-radius: 0.8rem;
`

export const CardLogoText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.7rem;
`

export const TextCrossed = styled.p`
  color: #858fad;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.8rem;
  text-decoration-line: line-through;
`

export const CardLogoTextBadge = styled.div`
  display: flex;
  width: 9.2rem;
  padding: 0.4rem 1rem 0.6rem 1rem;
  align-items: center;
  border-radius: 3rem;
  background: #292e3d;
  color: white;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
`

export const CardContentRight = styled.div<{ $isBig?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;

  ${({ $isBig }) =>
    $isBig
      ? css`
          padding: 1.5rem 10rem 1rem 2rem;
        `
      : css`
          padding: 1.5rem 1rem 1rem 2rem;
        `}
`

export const CardContentRightTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const CardContentRightSubtitle = styled.p`
  color: white;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
  text-wrap: wrap;
`

export const CardTitleBig = styled.h3`
  && {
    color: white;
    font-family: coolvetica, Arial, Helvetica, sans-serif;
    font-size: 3.6rem;
    font-weight: 400;
    line-height: 4.2rem;
    margin-bottom: 0;

    @media (max-width: 1279px) {
      font-size: 3rem;
      line-height: 3.6rem;
    }

    @media (max-width: 767px) {
      font-size: 2rem;
      line-height: 2.6rem;
    }
  }
`

export const CardTitleSmall = styled.h4`
  && {
    color: white;
    font-family: coolvetica, Arial, Helvetica, sans-serif;
    font-size: 2.4rem;
    font-weight: 400;
    line-height: 3rem;
    margin-bottom: 0;

    @media (max-width: 767px) {
      font-size: 2rem;
      line-height: 2.6rem;
    }
  }
`

export const ShowMoreButton = styled.button`
  display: flex;
  width: 15.4rem;
  height: 5rem;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  padding: 0 2rem;
  border-radius: 0.5rem;
  border: none;
  background: white;
  color: black;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #edeff3;
    color: #3a64f8;
    transition: all 0.1s ease;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`
